export const AUDIENCE_LABELS = {
  sales: 'Sales & Partnerships',
  marketing: 'Marketing',
  students: 'Finance Students',
  all: 'All audiences',
};
